import React from "react";
import { useIdle } from "react-use";
import { useNavigate } from "react-router-dom";
import CustomSnackbar from "../src/utils/CustomSnackbar";
import axios from "axios";
import useDetails from "src/hooks/useDetails";
import { useLocation } from "react-router-dom";
import { useAuthStore } from "./stores/useAuthStore";

const UserActivityDetector = () => {
  const userDetails = useDetails();
  const isIdle = useIdle(600000); // 10 minutes of inactivity
  const navigate = useNavigate();
  const location = useLocation(); // 👈 Add this line

  const { logout } = useAuthStore();

  const [openSnack, setOpenSnack] = React.useState({
    open: false,
    severity: null,
    message: null,
  });

  const handleLogout = React.useCallback(() => {
    const userdata = {
      user_id: userDetails?.user_id,
    };

    axios
      .post(
        `${process.env.REACT_APP_KAIZEN_API}/api/dev1/2222/idlelogout`,
        userdata
      )
      .then((response) => {
        if (response.data === "success") {
          console.log("Logged out on server");
          logout();
        }
      })
      .catch((err) => {
        console.log("Logout error");
      });
  }, [userDetails]);

  React.useEffect(() => {
    if (isIdle) {
      sessionStorage.clear();
      navigate("/login");
      setOpenSnack({
        open: true,
        severity: "info",
        message:
          "Due to 10 minutes of inactivity, you have been logged out. Please refresh this page and Sign In to continue.",
      });
      handleLogout();
    }
  }, [isIdle, navigate, handleLogout]);
  // 🟢 NEW: Close snackbar when on login page
  React.useEffect(() => {
    if (location.pathname != "/login") {
      setOpenSnack({
        open: false,
        severity: null,
        message: null,
      });
    }
  }, [location]);

  const { open, severity, message } = openSnack;

  return (
    <div>{CustomSnackbar(open, severity, message, ["bottom", "center"])}</div>
  );
};

export default UserActivityDetector;
